export enum DeckDecorationType {
    SUMMARY = "Executive Summary",
    EMAIL = "E-mail Draft",
}

export enum DeckDecorationLanguages {
    ENGLISH = "EN",
    CHINESE = "CN",
    JAPANESE = "JP",
    GERMAN = "DE",
    FRENCH = "FR",
    ITALIAN = "IT",
    SPANISH = "ES",
    PORTUGUESE = "PT",
}

export const DECK_DECORATION_LOADING_TEXT =
    "Generation can take 30+ seconds...";

export const DECK_DECORATION_RESPONSE_ID_FAILURE =
    "DECK_DECORATION_RESPONSE_FAILURE";

export const DECK_DECORATION_FAILURE_MESSAGE =
    "Error fetching response, please try again.";
